/** ------------------------------------------------------------------------- *
 * Chart,js Initialization *
 * -------------------------------------------------------------------------- *
 * @module Charts
 * @desc Initializes the Chart.js plugin
 */

/* global CHART_ARR, Chart */

/** ------------ *
 * Module Export *
 * ------------- *
 */

const Charts = {
    /**
     * @property Charts.init
     * @method
     * @desc Initializes the chart(s)
     */

    init() {
        CHART_ARR.forEach((chart) => {
            const chart_el = document.querySelector(chart.selector);

            if (chart_el && chart.config) {
                new Chart(chart_el, chart.config);
            }
        });
    },
};

export default Charts;
